<i18n>
{
	"en": {
		"ata": "Confirmed Arrival",
		"atd": "Confirmed Departure",
		"notRegistered": "Not registered"
	},
	"no": {
		"ata": "Bekreftet Ankomst",
		"atd": "Bekreftet Avgang",
		"notRegistered": "Ikke registrert"
	}
}
</i18n>

<template>
	<t-form-group :title="$t(field)">
		<t-text-input
			:value="formatedValue"
			:placeholder="$t('notRegistered')"
			width="100%"
			disabled
		/>
	</t-form-group>
</template>

<script>
import {
	displayDateFormatter,
} from '@/core';

export default {
	name: 'ActualTime',
	props: {
		field: String,
		dateTimeObject: Object,
	},
	computed: {
		formatedValue() {
			// Sending true as second parameter to show time in addition to date.
			return this.dateTimeObject ? displayDateFormatter(this.dateTimeObject.date, true) : undefined;
		},
	},
};
</script>